var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"inviter"}},[_c('div',{staticClass:"img",style:(_vm.$bgd(_vm.img))}),_c('p',[_c('b',[_vm._v(_vm._s(_vm.name))]),_c('span',[_vm._v("邀请你体验欧美外教真人直播课")])])])}
var staticRenderFns = []

export { render, staticRenderFns }